import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useAxiosInstance } from "../../../../services/Interceptor";
import { deleteProfileVideoAction } from "../../../../store/ProfileVideoActions";
import ReactPlayer from "react-player";
import { useState } from "react";
import ConfirmModal from "../../../../components/ConfirmModel";
import { toast } from "react-toastify";

export default function ShowVideo({ profileVideo }) {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const [showModal, setShowModal] = useState(false);

  const handleDeleteVideo = async () => {
    try {
      await dispatch(deleteProfileVideoAction(apiInstance, profileVideo.id));
      setShowModal(false);
      toast.info(" Video deleted successfully.");
    } catch (error) {
      console.error("Error deleting video:", error);
      toast.error(" Failed to delete the video.");
    }
  };

  return (
    <div className="flex items-center space-x-5">
      <div className="border-t-4 border-b-4 ">
        <div className="w-[200px] h-[120px] bg-black rounded-md">
          <ReactPlayer
            controls
            light={true}
            src={profileVideo.filePath}
            playsInline={true}
            width={200}
            height={120}
            className="rounded-md"
          />
        </div>
      </div>
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => setShowModal(true)}
        className="text-red-700 cursor-pointer hover:scale-105 active:scale-95"
      />

      <ConfirmModal
        show={showModal}
        tital="Delete Video?"
        message="Are you sure you want to delete the video?"
        onConfirm={handleDeleteVideo}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
}
